import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CareKycComponent } from 'src/app/components/care-kyc/care-kyc.component';
import { HealthClaimSettlementComponent } from 'src/app/components/health-claim-settlement/health-claim-settlement.component';
import { ConnectionService } from 'src/app/services/connection.service';
import { DataFieldsService } from 'src/app/services/data-fields.service';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-care-quote-confirmation',
  templateUrl: './care-quote-confirmation.page.html',
  styleUrls: ['./care-quote-confirmation.page.scss'],
})
export class CareQuoteConfirmationPage implements OnInit {
  disableNcbAddOn: boolean = false;
  disableExpertOp: boolean = false;
  careConfirmationForm: FormGroup;
  radioBtn: any = "rd-prm";
  toDisplayData = {
    totalPremiumAmount: '0',
    basePremiumAmount: '0',
    addPremiumAmount: '0',
    additionalCoverAmount: '0'
  };
  cashless: boolean = true;
  careQuoteReq: any;
  careCoverAmntList: any;
  unlimitAddon: boolean = false;
  opdAddon: boolean = false;
  ncbAdd: boolean = false;
  expertAdd: boolean = false;
  everyDayAdd: boolean = false;
  airAmbulance: boolean = false;
  reductionAdd: boolean = false;
  showEveryDayCare: boolean = false;
  showAddonsRed: boolean = false;
  coPaymentWaiver: boolean = false;
  showAirambulance: boolean = false;
  careQuoteRes: any;
  members: any;
  addOns: any = [];
  addOnArray: any = [];
  addBtnShow: boolean;
  careShieldAdd: boolean;
  dailyAllowanceAdd: any;
  coPayWaiverAdd: any;
  opdValue: string;
  upgradedQuoteReqObj: any;
  isBuyBackAddon: boolean = false;
  showDeductibles: boolean = true;
  enhanceHealthQuoteList: any = [];
  daSIList: any = [
    { value: "1000" },
    { value: "2000" },
    { value: "3000" },
    { value: "4000" },
    { value: "5000" },
    { value: "6000" },
    { value: "7000" },
    { value: "8000" },
    { value: "9000" },
    { value: "10000" }
  ]


  careProducts: any = {
    care: false,
    enhance1Individual: false,
    enhance1Floater: false,
  }

  insurerlogo: any = '';
  productName: any = '';
  fhoSumInsuredList: any = this._dataFields.getFhoSumInsuredList();
  mciSumInsuredList: any = this._dataFields.getMciSumInsuredList();
  mciSIList = [
    { id: 1, value: "150000", label: "1.5" },
    { id: 1, value: "200000", label: "2" },
    { id: 1, value: "300000", label: "3" },
    { id: 1, value: "400000", label: "4" },
    { id: 1, value: "500000", label: "5" },
    { id: 1, value: "1000000", label: "10" },
    { id: 1, value: "1500000", label: "15" },
    { id: 1, value: "2000000", label: "20" },
    { id: 1, value: "2500000", label: "25" },
  ]
  rcfSumInsuredList: any = this._dataFields.getRcfSumInsuredList();
  rciSumInsuredList: any = this._dataFields.getRciSumInsuredList();
  compfCompiSumInsuredList: any = this._dataFields.getcompfCompiSumInsuredList();
  ysfSumInsuredList: any = this._dataFields.getYsfSumInsuredList();
  ysiSumInsuredList: any = this._dataFields.getYsiSumInsuredList();

  ysfYsiSiList = [
    { id: 1, value: "300000", label: "3" },
    { id: 1, value: "500000", label: "5" },
    { id: 1, value: "1000000", label: "10" },
    { id: 1, value: "1500000", label: "15" },
    { id: 1, value: "2000000", label: "20" },
    { id: 1, value: "2500000", label: "25" },
    { id: 1, value: "5000000", label: "50" },
    { id: 1, value: "7500000", label: "75" },
    { id: 1, value: "10000000", label: "100" },
  ]


  starProducts: any = {
    isStar: false,
    familyHealthOptima: false,
    mediClassicIndividual: false,
    redCarpetIndividual: false,
    redCarpetFloater: false,
    comprehensiveIndividual: false,
    comprehensiveFloater: false,
    youngStarIndividual: false,
    youngStarFloater: false,
    superSurplusFloater: false,
    superSurplusIndividual: false
  }
  reqDataObj: any;
  resDataObj: any;
  topUpCoverAmntList: any = [];
  deductibleList: any = [];
  topUpPvt: any;
  insurerArray: any;
  youngerCount: any;
  sumValue: any;
  sumInsuredAmt: any;
  deductibleAmt: any;
  hidePlanType: boolean;
  careRes: any;
  noAddons: boolean;
  addOnsParam: boolean = false;
  careTpResp: any;
  serverQuoteRequest: any;
  starTopUpRes: any;
  policyType: any;
  addonsPremium: any;
  adPremium: any;
  nrPremium: any;
  tenureHide2: boolean;
  tenureHide3: boolean;
  premiumYear: string;

  get emiOptionValue() {
    return this.careConfirmationForm.get("starEmiOption").value;
  }

  constructor(private fb: FormBuilder,
    private _dataFields: DataFieldsService,
    private _datePipe: DatePipe,
    private strg: StorageService,
    private apiService: ConnectionService,
    private toast: ToastService,
    private loader: LoaderService,
    private route: ActivatedRoute,
    private router: Router, private modalCtrl: ModalController) { }

  ngOnInit() {
    this.careCoverAmntList = this._dataFields.getCareCoverage()
    this.careCoverAmntList.forEach((element, index) => {
      if (element.id == 0) this.careCoverAmntList.splice(index, 1);
    });
    this.careCoverAmntList.splice(this.careCoverAmntList.indexOf(0), 1)
    console.log(this.careCoverAmntList)
    this.careConfirmationForm = this.fb.group({
      coverAmnt: ['', [Validators.required]],
      policyTerm: ['', [Validators.required]],
      planType: [''],
      termAmounts: [''],
      starEmiOption: ['fullPay'],
      sumInsured: [''],
      topUpCoverAmnt: [''],
      deductibles: [''],
    })
  }
  isAbove60: boolean = false;
  ionViewDidEnter() {
    this.deductibleList = this._dataFields.getTopDeductible();
    this.strg.getStoreData("hlQuoteForUpgrade").then(res => {
      this.starTopUpRes = res
      console.log(res)
      this.insurerArray = res.ageDetail;
      this.youngerCount = res.noOfchildrens;
      this.upgradedQuoteReqObj = res.req;
      this.productName = res.productName;
      this.insurerlogo = res.insurerLogoUrl;
      if (res.productName === "Care") {
        this.noAddons = false
        let above60 = res.req.insurer.filter(item => item.age > 60);
        if (above60.length > 0)
          this.isAbove60 = true;
        this.careProducts.care = true;
        Object.keys(this.starProducts).forEach((key) => {
          this.starProducts[key] = false;
        });
        this.careQuoteReq = this.upgradedQuoteReqObj;
        this.autoFillHlQuoteUpgradeForm(this.careQuoteReq);
        this.updateCareQuote();
      } else if (res.productName === "Family Health Optima") {
        this.noAddons = true;
        this.careProducts.care = false;
        Object.keys(this.starProducts).forEach((key) => {
          if (key === "familyHealthOptima" || key === "isStar")
            this.starProducts[key] = true;
          else
            this.starProducts[key] = false;
        });
        this.autoFillHlQuoteUpgradeForm(res);
        this.getStarQuote();
      } else if (res.productName === "Medi-Classic Individual") {
        this.noAddons = true;
        this.careProducts.care = false;
        Object.keys(this.starProducts).forEach((key) => {
          if (key === "mediClassicIndividual" || key === "isStar")
            this.starProducts[key] = true;
          else
            this.starProducts[key] = false;
        });
        this.autoFillHlQuoteUpgradeForm(res);
        this.getStarQuote();
      }
      else if (res.productName === "Red Carpet Floater") {
        this.noAddons = true;
        this.careProducts.care = false;
        Object.keys(this.starProducts).forEach((key) => {
          if (key === "redCarpetFloater" || key === "isStar")
            this.starProducts[key] = true;
          else
            this.starProducts[key] = false;
        });
        this.autoFillHlQuoteUpgradeForm(res);
        this.getStarQuote();
      }
      else if (res.productName === "Red Carpet Individual") {
        this.noAddons = true;
        this.careProducts.care = false;
        Object.keys(this.starProducts).forEach((key) => {
          if (key === "redCarpetIndividual" || key === "isStar")
            this.starProducts[key] = true;
          else
            this.starProducts[key] = false;
        });
        this.autoFillHlQuoteUpgradeForm(res);
        this.getStarQuote();
      }
      else if (res.productName === "Comprehensive Floater") {
        this.noAddons = true;
        this.careProducts.care = false;
        Object.keys(this.starProducts).forEach((key) => {
          if (key === "comprehensiveFloater" || key === "isStar")
            this.starProducts[key] = true;
          else
            this.starProducts[key] = false;
        });
        this.autoFillHlQuoteUpgradeForm(res);
        this.getStarQuote();
      }
      else if (res.productName === "Comprehensive Individual") {
        this.noAddons = true;
        this.careProducts.care = false;
        Object.keys(this.starProducts).forEach((key) => {
          if (key === "comprehensiveIndividual" || key === "isStar")
            this.starProducts[key] = true;
          else
            this.starProducts[key] = false;
        });
        this.autoFillHlQuoteUpgradeForm(res);
        this.getStarQuote();
      }
      else if (res.productName === "Young Star Floater") {
        this.noAddons = true;
        this.careProducts.care = false;
        this.ysfYsiSiList.shift();
        Object.keys(this.starProducts).forEach((key) => {
          if (key === "youngStarFloater" || key === "isStar")
            this.starProducts[key] = true;
          else
            this.starProducts[key] = false;
        });
        this.careConfirmationForm.get('planType').setValue('GOLD')
        this.autoFillHlQuoteUpgradeForm(res);
        this.getStarQuote();
      }
      else if (res.productName === "Young Star Individual") {
        this.noAddons = true;
        this.careProducts.care = false;
        Object.keys(this.starProducts).forEach((key) => {
          if (key === "youngStarIndividual" || key === "isStar")
            this.starProducts[key] = true;
          else
            this.starProducts[key] = false;
        });
        this.careConfirmationForm.get('planType').setValue('GOLD')
        this.autoFillHlQuoteUpgradeForm(res);
        this.getStarQuote();
      }
      else if (res.productName === "Super Surplus Floater") {
        this.noAddons = true;
        this.topUpCoverAmntList = this._dataFields.getTopupSumInsured().filter(item => item.value !== 4)
        this.radioBtn = 'active-rd-prm'
        this.hidePlanType = true
        this.careProducts.care = false;
        this.productName = 'Super Surplus Floater'
        Object.keys(this.starProducts).forEach((key) => {
          if (key === "superSurplusFloater" || key === "isStar")
            this.starProducts[key] = true;
          else
            this.starProducts[key] = false;
        });
        this.careConfirmationForm.get('planType').setValue('GOLD')
        this.autoFillHlQuoteUpgradeForm(res);
        this.getStarQuote();
      }
      else if (res.productName === "Super Surplus Individual") {
        this.noAddons = true;
        this.topUpCoverAmntList = this._dataFields.getTopupSumInsured()
        this.radioBtn = 'active-rd-prm'
        this.hidePlanType = true
        this.careProducts.care = false;
        this.productName = 'Super Surplus Individual'
        Object.keys(this.starProducts).forEach((key) => {
          if (key === "superSurplusIndividual" || key === "isStar")
            this.starProducts[key] = true;
          else
            this.starProducts[key] = false;
        });

        this.careConfirmationForm.get('planType').setValue('GOLD')
        this.careConfirmationForm.get('topUpCoverAmnt').setValue('1000000')
        this.careConfirmationForm.get('deductibles').setValue('500000')
        this.autoFillHlQuoteUpgradeForm(res);
        this.getStarQuote();
      }
      else if (res.productName === 'Enhance 1') {
        this.noAddons = false;
        // this.careTpResp = JSON.parse(res.res[0].data)
        this.careTpResp = res.res
        // let careTopUpResp = this.careTpResp.find(item => item.productName === 'Enhance 1');
        let careTopUpResp;
        this.careTpResp.forEach(ress => {
          if (ress) {
            if (ress.productName === 'Enhance 1') {
              careTopUpResp = ress
              if (careTopUpResp.requestToPartner.postedField.field_9 === "Individual") {
                this.careProducts.enhance1Individual = true;
              }
              else {
                this.careProducts.enhance1Floater = true;
              }
            }
          }
        })
        this.productName = res.productName;
        this.careCoverAmntList = this._dataFields.getEnhanceSumInsured()
        this.deductibleList = this._dataFields.getEnhanceDeductible();

        if (this.addOnsParam === true) {
          this.toDisplayData.totalPremiumAmount = careTopUpResp.resfromPartner.data.outputFields[1].premium
          this.toDisplayData.basePremiumAmount = careTopUpResp.resfromPartner.data.outputFields[0].premium
          this.toDisplayData.additionalCoverAmount = String(careTopUpResp.resfromPartner.data.outPutField[1].premium - careTopUpResp.resfromPartner.data.outputFields[0].premium)
        }
        else if (this.addOnsParam === false) {
          this.toDisplayData.totalPremiumAmount = careTopUpResp.resfromPartner.data.outputFields[0].premium
          this.toDisplayData.basePremiumAmount = careTopUpResp.resfromPartner.data.outputFields[0].premium
          this.toDisplayData.additionalCoverAmount = '0'
        }
        this.careProducts.care = false;
        // let carTp = this.careTpResp.filter(item => item.productName === 'Enhance 1')
        // if (carTp[0].requestToPartner.postedField.field_9 === "Individual") {
        //   this.careProducts.enhance1Individual = true;
        // }
        // else {
        //   this.careProducts.enhance1Floater = true;
        // }
        this.hidePlanType = false
        this.radioBtn = 'rd-prm'
        this.careConfirmationForm.get('topUpCoverAmnt').setValue('1000000')
        this.careConfirmationForm.get('deductibles').setValue('500000')
        this.autoFillHlQuoteUpgradeForm(res);
        this.getStarQuote();
      }
    })
    this.careConfirmationForm.valueChanges.pipe(
      debounceTime(1000),
      distinctUntilChanged()
    ).subscribe(() => {
      if (this.careProducts.care === true) {

        this.updateCareQuote();
      }
      else {
        this.getStarQuote();
      }
    });
  }
  planTypeChange(e) {
    if (e.target.value === 'SILVER' && this.starProducts.superSurplusFloater) {
      this.topUpCoverAmntList = this._dataFields.getTopupSumInsured().filter(item => item.value === 5)
      this.careConfirmationForm.get('topUpCoverAmnt').setValue(1000000)
      let temp3 = this._dataFields.getTopDeductible();
      let temp4 = []
      temp3.forEach(element => {
        if (element.value === 1 || element.value === 2) {
          temp4.push(element)
        }
      })
      this.deductibleList = temp4;
      this.careConfirmationForm.get('deductibles').setValue(this.deductibleList[0].label)
    }
    else if (e.target.value === 'SILVER' && this.starProducts.superSurplusIndividual) {
      this.deductibleList = this._dataFields.getTopDeductible().filter(item => item.value === 1)
      this.careConfirmationForm.get('deductibles').setValue(300000)
      let temp = this._dataFields.getTopupSumInsured();
      let temp1 = []
      temp.forEach(element => {
        if (element.value === 4 || element.value === 5) {
          temp1.push(element)
        }
      })
      this.topUpCoverAmntList = temp1;
      if (this.careConfirmationForm.get('topUpCoverAmnt').value != 1000000) {
        this.careConfirmationForm.get('topUpCoverAmnt').setValue(this.topUpCoverAmntList[0].label)
      }
    }
    else if ((e.target.value === 'GOLD' && this.starProducts.superSurplusIndividual) || (e.target.value === 'GOLD' && this.starProducts.superSurplusFloater)) {
      this.topUpCoverAmntList = this._dataFields.getTopupSumInsured()
      this.deductibleList = this._dataFields.getTopDeductible()
    }
    if (this.starProducts.superSurplusFloater === true) {
      this.topUpPvt.sumInsuredAmount = this.careConfirmationForm.get('topUpCoverAmnt').value;
      this.topUpPvt.deductible = this.careConfirmationForm.get('deductibles').value;
      this.topUpPvt.planType = this.careConfirmationForm.get('planType').value;
    }
    else if (this.starProducts.superSurplusIndividual === true) {
      this.topUpPvt.membersArray = []
      this.topUpPvt.membersArray.push({
        'age': this.insurerArray[0].age,
        "sumInsuredAmount": this.careConfirmationForm.get('topUpCoverAmnt').value,
        "deductible": this.careConfirmationForm.get('deductibles').value,
        "planType": this.careConfirmationForm.get('planType').value,
        'memberType': this.insurerArray[0].name
      })
    }
  }
  autoFillHlQuoteUpgradeForm(data) {
    let coverAmnt = '';
    let policyTerm = '';
    let termAmounts = '';
    if (this.careProducts.care) {
      coverAmnt = data.careQuoteRequest.postedField.field_2;
      policyTerm = data.careQuoteRequest.postedField.field_4;
      termAmounts = data.careQuoteRequest.postedField.outPutField;
    } else if (this.starProducts.familyHealthOptima) {
      coverAmnt = data.sumInsured;
      policyTerm = '1 Year';
      this.careConfirmationForm.get('coverAmnt').setValue(coverAmnt)
    }
    else if (!this.starProducts.familyHealthOptima && this.starProducts.isStar) {
      coverAmnt = data.sumInsured;
      policyTerm = data.term;
      this.careConfirmationForm.get('coverAmnt').setValue(coverAmnt)
      if (this.starProducts.superSurplusFloater || this.starProducts.superSurplusIndividual) {
        this.careConfirmationForm.get('planType').setValue('GOLD')
        this.careConfirmationForm.get('topUpCoverAmnt').setValue('1000000')
        this.careConfirmationForm.get('deductibles').setValue('500000')
        policyTerm = data.term + " Year";
        coverAmnt = null
      }
    }
    else if (this.careProducts.enhance1Individual || this.careProducts.enhance1Floater) {
      coverAmnt = this.careConfirmationForm.value.topUpCoverAmnt
      policyTerm = data.term + " Year";
    }
    this.careConfirmationForm.get('coverAmnt').setValue(coverAmnt);
    if (this.starProducts.isStar === false && this.starProducts.superSurplusFloater === false && this.starProducts.superSurplusIndividual === false) {
      this.careConfirmationForm.get('coverAmnt').setValue(coverAmnt)
      this.sumInsuredAmt = this.careConfirmationForm.get('coverAmnt').value === '10000000' ? '1 cr' : this.careConfirmationForm.get('coverAmnt').value.slice(0, -5) + " Lac";
      this.deductibleAmt = this.careConfirmationForm.get('deductibles').value === '10000000' ? '1 cr' : this.careConfirmationForm.get('deductibles').value.slice(0, -5) + " Lac";
    }
    this.careConfirmationForm.get('policyTerm').setValue(policyTerm)
    this.careConfirmationForm.get('termAmounts').setValue(termAmounts)
    if (this.starProducts.mediClassicIndividual && (coverAmnt === "20" || coverAmnt === "25")) {
      this.careConfirmationForm.get("planType").setValue("GOLD")
      this.careConfirmationForm.get("planType").disable({ onlySelf: true });
    } else if (this.starProducts.mediClassicIndividual) {
      coverAmnt = data.sumInsured;
      this.careConfirmationForm.get('coverAmnt').setValue(coverAmnt)
      this.careConfirmationForm.get("planType").setValue("SILVER")
    }
  }
  mciSICheckForPlanType() {
    let coverAmnt = this.careConfirmationForm.get('coverAmnt').value === "1.5" ? "150000" : this.careConfirmationForm.get('coverAmnt').value + "00000";
    if (coverAmnt === "150000" || coverAmnt === "200000") {
      this.careConfirmationForm.get("planType").setValue("SILVER");
      this.careConfirmationForm.get("planType").disable({ onlySelf: true });
    } else if (coverAmnt === "2000000" || coverAmnt === "2500000") {
      this.careConfirmationForm.get("planType").setValue("GOLD");
      this.careConfirmationForm.get("planType").disable({ onlySelf: true });
    } else {
      this.careConfirmationForm.get("planType").enable({ onlySelf: true });
    }
  }
  ysiYsfSICheckForPlanType() {
    let coverAmnt = this.careConfirmationForm.get('coverAmnt').value + "00000";
    if (coverAmnt === "300000") {
      this.careConfirmationForm.get("planType").setValue("GOLD");
      this.careConfirmationForm.get("planType").disable({ onlySelf: true });
    } else {
      this.careConfirmationForm.get("planType").enable({ onlySelf: true });
    }
  }
  isInstallment: any = 0;
  installmentType: any = 0;

  getStarQuote() {
    let productName = "";
    let coverType = "";
    let term = 0;
    if (this.careConfirmationForm.get('policyTerm').value === "1 Year") {
      term = 1;
    } else if (this.careConfirmationForm.get('policyTerm').value === "2 Year") {
      term = 2;
    } else if (this.careConfirmationForm.get('policyTerm').value === "3 Year") {
      term = 3;
    }
    this.isInstallment = 0;
    this.installmentType = 0;
    if (this.emiOptionValue === "quarterly") {
      this.isInstallment = 1;
      this.installmentType = 2;
    } else if (this.emiOptionValue === "halfyearly") {
      this.isInstallment = 1;
      this.installmentType = 3;
    }
    console.log("this.starTopUpRes.reqrrerererererer", this.starTopUpRes)
    this.topUpPvt = {
      "name": this.starTopUpRes.req.name,
      "email": this.starTopUpRes.req.email,
      "mobile": this.starTopUpRes.req.mobile,
      "gender": this.starTopUpRes.req.gender,
      "noOfchildrens": this.starTopUpRes.req.noOfchildrens,
      "isInstallment": this.isInstallment,
      "installmentType": this.installmentType,
      "planType": this.careConfirmationForm.get('planType').value,
      "schemeId": this.starTopUpRes.req.schemeId,
      "policyTerm": term,
      //"policyType": this.policyType,
      "postalCode": this.starTopUpRes.req.postalCode,
      "membersArray": []
    }
    if (this.starProducts.isStar === true && this.starProducts.comprehensiveFloater || this.starProducts.comprehensiveIndividual || this.starProducts.familyHealthOptima || this.starProducts.mediClassicIndividual || this.starProducts.redCarpetFloater || this.starProducts.redCarpetIndividual || this.starProducts.youngStarFloater || this.starProducts.youngStarIndividual) {
      this.upgradedQuoteReqObj.starHealthQuoteRequest.isInstallment = this.isInstallment;
      this.upgradedQuoteReqObj.starHealthQuoteRequest.installmentType = this.installmentType;
      if (this.starProducts.familyHealthOptima) {
        coverType = "Floater";
        this.upgradedQuoteReqObj.starHealthQuoteRequest.sumInsuredId = this.fhoSumInsuredList.find(item => item.tens === this.careConfirmationForm.get('coverAmnt').value).siId
      } else if (this.starProducts.mediClassicIndividual) {
        coverType = "Individual";
        let coverAmnt = this.careConfirmationForm.get('coverAmnt').value === "1.5" ? "150000" : this.careConfirmationForm.get('coverAmnt').value + "00000";
        let mciSumInsuredId = "";
        if (this.careConfirmationForm.get("planType").value === "SILVER") {
          mciSumInsuredId = this.mciSumInsuredList.filter(item => item.value === coverAmnt && item.plan === "SILVER")[0].siId;
        } else if (this.careConfirmationForm.get("planType").value === "GOLD") {
          mciSumInsuredId = this.mciSumInsuredList.filter(item => item.value === coverAmnt && item.plan === "GOLD")[0].siId;
        }
        this.upgradedQuoteReqObj.starHealthQuoteRequest.period = term;
        this.upgradedQuoteReqObj.starHealthQuoteRequest.insureds.forEach(item => {
          item.sumInsuredId = mciSumInsuredId
        });
      } else if (this.starProducts.redCarpetFloater) {
        coverType = "Floater";
        this.upgradedQuoteReqObj.starHealthQuoteRequest.period = term;
        this.upgradedQuoteReqObj.starHealthQuoteRequest.sumInsuredId = this.rcfSumInsuredList.find(item => item.tens === this.careConfirmationForm.get('coverAmnt').value).siId
      } else if (this.starProducts.redCarpetIndividual) {
        coverType = "Individual";
        this.upgradedQuoteReqObj.starHealthQuoteRequest.period = term;
        let rciSumInsuredId = this.rciSumInsuredList.find(item => item.tens === this.careConfirmationForm.get('coverAmnt').value).siId
        this.upgradedQuoteReqObj.starHealthQuoteRequest.insureds.forEach(item => {
          item.sumInsuredId = rciSumInsuredId
        });
      } else if (this.starProducts.comprehensiveFloater) {
        coverType = "Floater";
        this.upgradedQuoteReqObj.starHealthQuoteRequest.period = term;
        this.upgradedQuoteReqObj.starHealthQuoteRequest.sumInsuredId = this.compfCompiSumInsuredList.find(item => item.tens === this.careConfirmationForm.get('coverAmnt').value).siId
        this.upgradedQuoteReqObj.starHealthQuoteRequest.insureds.forEach(item => {
          item.buyBackPED = this.isBuyBackAddon === true ? 1 : 0;
        });
      } else if (this.starProducts.comprehensiveIndividual) {
        coverType = "Individual";
        this.upgradedQuoteReqObj.starHealthQuoteRequest.period = term;
        this.upgradedQuoteReqObj.starHealthQuoteRequest.insureds.forEach(item => {
          item.buyBackPED = this.isBuyBackAddon === true ? 1 : 0;
          item.sumInsuredId = this.compfCompiSumInsuredList.find(item => item.tens === this.careConfirmationForm.get('coverAmnt').value).siId;
        });
      } else if (this.starProducts.youngStarFloater === true) {
        coverType = "Floater";
        this.upgradedQuoteReqObj.starHealthQuoteRequest.period = term;
        let coverAmnt = this.careConfirmationForm.get('coverAmnt').value + "00000";
        let ysfSumInsuredId = "";
        if (this.careConfirmationForm.get("planType").value === "SILVER") {
          ysfSumInsuredId = this.ysfSumInsuredList.filter(item => item.value === coverAmnt && item.plan === "SILVER")[0].siId;
        } else if (this.careConfirmationForm.get("planType").value === "GOLD") {
          ysfSumInsuredId = this.ysfSumInsuredList.filter(item => item.value === coverAmnt && item.plan === "GOLD")[0].siId;
        }
        this.upgradedQuoteReqObj.starHealthQuoteRequest.sumInsuredId = ysfSumInsuredId;
      } else if (this.starProducts.youngStarIndividual === true) {
        coverType = "Individual";
        this.upgradedQuoteReqObj.starHealthQuoteRequest.period = term;
        let coverAmnt = this.careConfirmationForm.get('coverAmnt').value + "00000";
        let ysiSumInsuredId = "";
        if (this.careConfirmationForm.get("planType").value === "SILVER") {
          ysiSumInsuredId = this.ysiSumInsuredList.filter(item => item.value === coverAmnt && item.plan === "SILVER")[0].siId;
        } else if (this.careConfirmationForm.get("planType").value === "GOLD") {
          ysiSumInsuredId = this.ysiSumInsuredList.filter(item => item.value === coverAmnt && item.plan === "GOLD")[0].siId;
        }
        this.upgradedQuoteReqObj.starHealthQuoteRequest.insureds.forEach(item => {
          item.sumInsuredId = ysiSumInsuredId
        });
      }
      this.loader.showLoader()
      this.apiService.getStarhealthQuotePvt(this.upgradedQuoteReqObj).subscribe(res => {
        this.loader.hideLoader();
        let starQuoteRes = JSON.parse(res.data);
        this.careQuoteRes = starQuoteRes.starHealthQuoteResponse;
        let dd = JSON.parse(starQuoteRes.starHealthQuoteResponse.insuranceQuoteRequest.reqParam);
        let responsObj = JSON.parse(starQuoteRes.starHealthQuoteResponse.responseParam);
        let dddd = JSON.parse(starQuoteRes.starHealthQuoteRequest.reqParam);
        if (responsObj.installmentPlan) {
          this.toDisplayData.totalPremiumAmount = responsObj.installmentTotalPremium;
          this.toDisplayData.basePremiumAmount = responsObj.installmentTotalPremium;
        } else {
          this.toDisplayData.totalPremiumAmount = responsObj.totalPremium;
          this.toDisplayData.basePremiumAmount = responsObj.totalPremium;
        }
        this.members = {
          insurerName: "Star Health and Allied Insurance Co Ltd",
          insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
          productName: this.productName,
          sumInsured: this.careConfirmationForm.get('coverAmnt').value,
          term: this.careConfirmationForm.get("policyTerm").value,
          coverType: coverType,
          premiumAmount: this.toDisplayData.totalPremiumAmount,
          installmentType: this.installmentType,
          res: res.data,
          req: this.upgradedQuoteReqObj
        }
        this.reqDataObj = this.upgradedQuoteReqObj;
        this.resDataObj = starQuoteRes;
        this.resDataObj.starHealthQuoteResponse.insuranceQuoteRequest.reqParam = dd;
        this.resDataObj.starHealthQuoteResponse.responseParam = responsObj;
        this.resDataObj.starHealthQuoteRequest.reqParam = dddd;
      }, err => {
        this.loader.hideLoader();
      })
    }
    else if (this.starProducts.superSurplusFloater || this.starProducts.superSurplusIndividual) {
      if (this.starProducts.superSurplusFloater) {
        this.topUpPvt.policyType = 'Floater'
        this.topUpPvt.sumInsuredAmount = this.careConfirmationForm.get('topUpCoverAmnt').value,
          this.topUpPvt.deductible = this.careConfirmationForm.get('deductibles').value
        this.insurerArray.forEach(element => {
          this.topUpPvt.membersArray.push({
            'age': element.age,
            'memberType': element.name
          })
        })
      }
      else if (this.starProducts.superSurplusIndividual) {
        this.topUpPvt.policyType = 'Individual'
        this.insurerArray
        this.topUpPvt.membersArray.push({
          'age': this.insurerArray[0].age,
          "sumInsuredAmount": this.careConfirmationForm.get('topUpCoverAmnt').value,
          "deductible": this.careConfirmationForm.get('deductibles').value,
          "planType": this.careConfirmationForm.get('planType').value,
          'memberType': this.insurerArray[0].name
        })
      }
      this.loader.showLoader()
      this.apiService.getStarhealthTopUpQuotePvt(this.topUpPvt).subscribe(res => {
        this.loader.hideLoader()
        this.careQuoteRes = res.data.starHealthTopUpQuoteResponse
        if (this.careConfirmationForm.get('planType').value === 'GOLD' && this.careConfirmationForm.get('topUpCoverAmnt').value === '10000000') {
          this.sumInsuredAmt = '1cr'
        }
        else if (this.careConfirmationForm.get('planType').value === 'SILVER' && this.careConfirmationForm.get('topUpCoverAmnt').value === 1000000) {
          this.sumInsuredAmt = "10L"
        }
        else if (this.careConfirmationForm.get('planType').value === 'SILVER' && this.careConfirmationForm.get('topUpCoverAmnt').value === 700000) {
          this.sumInsuredAmt = "7L"
        }
        else {
          this.sumInsuredAmt = String(this.careConfirmationForm.get('topUpCoverAmnt').value).slice(0, -5) + "L"
        }
        this.deductibleAmt = String(this.careConfirmationForm.get('deductibles').value).slice(0, -5) + "L";
        this.members = {
          insurerName: "Star Health and Allied Insurance Co Ltd",
          insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
          productName: this.productName,
          sumInsured: this.sumInsuredAmt,
          deductible: this.deductibleAmt,
          coverType: coverType,
          premiumAmount: res.data.starHealthTopUpQuoteResponse.totalPremium,
          installmentType: this.installmentType,
        }
        if (this.emiOptionValue === 'quarterly' || this.emiOptionValue === 'halfyearly') {
          this.toDisplayData.totalPremiumAmount = res.data.starHealthTopUpQuoteResponse.installmentTax + res.data.starHealthTopUpQuoteResponse.installmentPremiumAmount
          this.toDisplayData.basePremiumAmount = res.data.starHealthTopUpQuoteResponse.installmentTax + res.data.starHealthTopUpQuoteResponse.installmentPremiumAmount
        }
        else {
          this.toDisplayData.totalPremiumAmount = res.data.starHealthTopUpQuoteResponse.totalPremium
          this.toDisplayData.basePremiumAmount = res.data.starHealthTopUpQuoteResponse.premium + res.data.starHealthTopUpQuoteResponse.serviceTax
        }
        this.reqDataObj = res.data.starHealthTopUpQuoteRequest;
        this.resDataObj = res.data.starHealthTopUpQuoteResponse;
        this.serverQuoteRequest = res.data.starServerQuoteRequest;

        this.reqDataObj.reqParam = JSON.parse(res.data.starHealthTopUpQuoteRequest.reqParam)
        this.loader.hideLoader()
      }, err => {
        this.loader.hideLoader();
      })
    }
    else if (this.careProducts.enhance1Individual) {
      this.topUpPvt.policyType = 'Individual'
      // let careTopUpResp = this.careTpResp.find(item => item.productName === 'Enhance 1')
      let careTopUpResp;
      this.careTpResp.forEach(ress => {
        if (ress) {
          if (ress.productName === 'Enhance 1') {
            careTopUpResp = ress
          }
        }
      })
      this.topUpPvt.noOfMembers = careTopUpResp.resfromPartner.data.inputFields[0].selectedValue
      this.topUpPvt.hasAddOn = this.addOnsParam
      console.log("wswswswswswswswswswswswwsws", this.starTopUpRes);
      this.topUpPvt.membersArray.push({
        "deductible": this.careConfirmationForm.get('deductibles').value,
        "sumInsuredAmount": this.careConfirmationForm.get('coverAmnt').value,
        'age': this.starTopUpRes.req.membersArray[0].age,
        'memberType': this.starTopUpRes.req.membersArray[0].memberType
      })
      // let findAge99 = this.starTopUpRes.req.find(item => item.age === '99') 
      // let findAge98 = this.starTopUpRes.req.find(item => item.age === '98') 
      // console.log(this.starTopUpRes,findAge99,findAge98)
      this.topUpPvt.policyTerm = term
      // if(findAge99){
      //   this.premiumYear = '1 Year'
      //   this.topUpPvt.policyTerm = this.premiumYear
      //   this.tenureHide2 = true;
      //   this.tenureHide3 = true;
      // }
      // else if(findAge98){
      //   if(this.starTopUpRes.term === '3'){
      //     this.premiumYear = '1 Year'
      //     this.topUpPvt.policyTerm = this.premiumYear
      //   }
      //   this.topUpPvt.policyTerm = term
      //   this.tenureHide3 = true;
      // }
      this.loader.showLoader()
      console.log("rrrrrrrrrrrrrsddfergfgertetertertet", this.topUpPvt);
      this.apiService.getCarehealthTopUpQuotePvt(this.topUpPvt).subscribe(res => {
        console.log("ttttttttttsddfergfgertetertertet", res);
        this.loader.hideLoader()
        res.data.careTopUpQuoteRequest.reqParam = JSON.parse(res.data.careTopUpQuoteRequest.reqParam)
        this.reqDataObj = res.data.careTopUpQuoteRequest
        this.resDataObj = res.data.careTopUpQuoteResponse
        this.careQuoteRes = res.data.careTopUpQuoteResponse.data
        if (this.addOnsParam === true) {
          // this.toDisplayData.totalPremiumAmount = careTopUpResp.resfromPartner.data.outputFields[1].premium
          // this.toDisplayData.basePremiumAmount = careTopUpResp.resfromPartner.data.outputFields[0].premium
          // this.adPremium = careTopUpResp.resfromPartner.data.outputFields[1].premium.replace(',', '')
          // this.nrPremium = careTopUpResp.resfromPartner.data.outputFields[0].premium.replace(',', '')
          // this.addonsPremium = Number(this.adPremium) - Number(this.nrPremium)
          // this.toDisplayData.additionalCoverAmount = String(this.addonsPremium)
          this.toDisplayData.totalPremiumAmount = this.careQuoteRes.outputFields[1].premium
          this.toDisplayData.basePremiumAmount = this.careQuoteRes.outputFields[1].premium
          this.toDisplayData.additionalCoverAmount = '0'
        }
        else if (this.addOnsParam === false) {
          // this.toDisplayData.totalPremiumAmount = careTopUpResp.resfromPartner.data.outputFields[0].premium
          // this.toDisplayData.basePremiumAmount = careTopUpResp.resfromPartner.data.outputFields[0].premium
          // this.toDisplayData.additionalCoverAmount = '0'
          this.toDisplayData.totalPremiumAmount = this.careQuoteRes.outputFields[0].premium
          this.toDisplayData.basePremiumAmount = this.careQuoteRes.outputFields[0].premium
          this.toDisplayData.additionalCoverAmount = '0'
        }
        this.sumInsuredAmt = this.careConfirmationForm.get('coverAmnt').value === '10000000' ? '1 cr' : this.careConfirmationForm.get('coverAmnt').value.slice(0, -5) + " Lac";
        this.deductibleAmt = this.careConfirmationForm.get('deductibles').value === '10000000' ? '1 cr' : this.careConfirmationForm.get('deductibles').value.slice(0, -5) + " Lac";

        this.members = {
          insurerName: "Care Health Insurance Limited",
          insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/careLogo.png",
          productName: 'Enhance 1',
          sumInsured: this.careQuoteRes.inputFields[6].selectedValue,
          term: this.careQuoteRes.inputFields[7].selectedValue,
          premiumAmount: this.careQuoteRes.outputFields[0].basePremiumCd[0],
          res: res.data
        }
      })
    }
    else if (this.careProducts.enhance1Floater) {
      // console.log("this.starTopUpResthis.starTopUpRes", this.starTopUpRes);
      // let careTopUpResp = this.careTpResp.find(item => item.productName === 'Enhance 1')
      let careTopUpResp;
      this.careTpResp.forEach(ress => {
        if (ress) {
          if (ress.productName === 'Enhance 1') {
            careTopUpResp = ress
          }
        }
      })
      this.sumInsuredAmt = this.careConfirmationForm.get('coverAmnt').value === '10000000' ? '1 cr' : this.careConfirmationForm.get('coverAmnt').value.slice(0, -5) + " Lac";
      this.deductibleAmt = this.careConfirmationForm.get('deductibles').value === '10000000' ? '1 cr' : this.careConfirmationForm.get('deductibles').value.slice(0, -5) + " Lac";
      this.topUpPvt.sumInsuredAmount = this.careConfirmationForm.get('coverAmnt').value;
      this.topUpPvt.deductible = this.careConfirmationForm.get('deductibles').value
      this.topUpPvt.hasAddOn = this.addOnsParam
      this.topUpPvt.planType = "GOLD";
      this.topUpPvt.noOfMembers = Number(this.starTopUpRes.insurerArray.length)
      this.topUpPvt.noOfchildrens = this.starTopUpRes.noOfchildrens
      if (this.starTopUpRes.req.length === 6) {
        this.starTopUpRes.schemeId = 0;
      }
      this.topUpPvt.policyType = 'Floater';
      this.starTopUpRes.insurerArray.forEach(element => {
        this.topUpPvt.membersArray.push({
          'age': element.age,
          'memberType': element.name
        })
      })
      // let findAge99 = this.starTopUpRes.req.find(item => item.age === '99') 
      // let findAge98 = this.starTopUpRes.req.find(item => item.age === '98') 
      // console.log(this.starTopUpRes,findAge99,findAge98)
      //     if(findAge99){
      //       this.premiumYear = '1 Year'
      //       this.topUpPvt.policyTerm = this.premiumYear
      //       this.tenureHide2 = true;
      //       this.tenureHide3 = true;
      //     }
      //     else if(findAge98){
      //       if(this.starTopUpRes.term === '3'){
      //         this.premiumYear = '1 Year'
      //         this.topUpPvt.policyTerm = this.premiumYear
      //       }
      //       this.topUpPvt.policyTerm = term
      //       this.tenureHide3 = true;
      //     }

      this.loader.showLoader()
      this.apiService.getCarehealthTopUpQuotePvt(this.topUpPvt).subscribe(res => {
        console.log("dfdfdfdfdfdf", res);
        this.loader.hideLoader()
        res.data.careTopUpQuoteRequest.reqParam = JSON.parse(res.data.careTopUpQuoteRequest.reqParam)
        this.reqDataObj = res.data.careTopUpQuoteRequest
        this.resDataObj = res.data.careTopUpQuoteResponse
        this.careQuoteRes = res.data.careTopUpQuoteResponse.data
        if (this.addOnsParam === true) {
          this.toDisplayData.totalPremiumAmount = this.careQuoteRes.outputFields[1].premium
          this.toDisplayData.basePremiumAmount = this.careQuoteRes.outputFields[0].premium
          this.adPremium = this.careQuoteRes.outputFields[1].premium.replace(',', '')
          this.nrPremium = this.careQuoteRes.outputFields[0].premium.replace(',', '')
          this.addonsPremium = Number(this.adPremium) - Number(this.nrPremium)
          this.toDisplayData.additionalCoverAmount = String(this.addonsPremium)
        }
        else if (this.addOnsParam === false) {
          console.log('Please select', this.careQuoteRes);
          this.toDisplayData.totalPremiumAmount = this.careQuoteRes.outputFields[0].premium
          this.toDisplayData.basePremiumAmount = this.careQuoteRes.outputFields[0].premium
          this.toDisplayData.additionalCoverAmount = '0'
        }
        this.members = {
          insurerName: "Care Health Insurance Limited",
          insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/careLogo.png",
          productName: 'Enhance 1',
          sumInsured: this.careQuoteRes.inputFields[6].selectedValue,
          term: this.careQuoteRes.inputFields[7].selectedValue,
          premiumAmount: this.careQuoteRes.outputFields[0].basePremiumCd[0],
          res: res.data
        }
      }, err => {
        this.loader.hideLoader()
      })
    }
    this.enhanceHealthQuoteList = []
    this.enhanceHealthQuoteList.push({
      addOns: this.addOnsParam
    });
    this.apiService.healthQuoteListChange(this.enhanceHealthQuoteList);
  }

  updateCareQuote() {
    if (this.careProducts.care) {
      if (this.careConfirmationForm.get('coverAmnt').value > 5) {
        this.disableNcbAddOn = false;
      }
      else {
        this.disableNcbAddOn = true;
        this.ncbAdd = true;
      }
      this.careQuoteReq.careQuoteRequest.postedField.field_2 = this.careConfirmationForm.get('coverAmnt').value;
      this.careQuoteReq.careQuoteRequest.postedField.field_4 = this.careConfirmationForm.get('policyTerm').value;
      this.careQuoteReq.careQuoteRequest.postedField.field_UA = this.unlimitAddon ? 1 : 0;
      this.careQuoteReq.careQuoteRequest.postedField.field_OPD = this.opdAddon ? 1 : 0;
      this.careQuoteReq.careQuoteRequest.postedField.field_DA = this.dailyAllowanceAdd ? 1 : 0;
      if (this.opdAddon) {
        this.careQuoteReq.careQuoteRequest.postedField.field_OPD_SI = this.selectedOpdAmount;
      }
      if (this.dailyAllowanceAdd) {
        this.careQuoteReq.careQuoteRequest.postedField.field_DA_SI = this.selectedDaAmount;
      }
      this.careQuoteReq.careQuoteRequest.postedField.field_EDC = this.everyDayAdd ? 1 : 0;
      this.careQuoteReq.careQuoteRequest.postedField.field_35 = this.airAmbulance ? 1 : 0;
      this.careQuoteReq.careQuoteRequest.postedField.field_43 = this.reductionAdd ? 1 : 0;
      this.careQuoteReq.careQuoteRequest.postedField.field_CS = this.careShieldAdd ? 1 : 0;
      this.careQuoteReq.careQuoteRequest.postedField.field_DA = this.dailyAllowanceAdd ? 1 : 0;
      this.careQuoteReq.careQuoteRequest.postedField.field_CPW = this.coPayWaiverAdd ? 1 : 0;

      if (this.ncbAdd) {
        this.careQuoteReq.careQuoteRequest.postedField.outPutField = "ncbPremium";
      }
      else {
        this.careQuoteReq.careQuoteRequest.postedField.outPutField = "field_8";
      }
      this.loader.showLoader();
      this.apiService.postCareQuoteFormPvt(this.careQuoteReq).subscribe(res => {
        this.loader.hideLoader();
        let respQuote = JSON.parse(res.data);
        let getQuoteResp = JSON.parse(respQuote.careQuoteResponse.responseParam)
        this.members = {
          insurerName: "Care Health Insurance Limited",
          insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/careLogo.png",
          productName: 'Care',
          sumInsured: this.careQuoteReq.careQuoteRequest.postedField.field_2,
          term: this.careQuoteReq.careQuoteRequest.postedField.field_4,
          premiumAmount: getQuoteResp.grandTotal.selectedValue,
          res: res.data
        }
        this.careQuoteRes = respQuote;
        console.log('toDisplayData', this.toDisplayData)
        console.log('getQuoteResp', getQuoteResp)
        if (this.ncbAdd) {
          console.log('ncbAdded')
          if (this.disableNcbAddOn) {
            console.log('run 1')
            this.toDisplayData.basePremiumAmount = getQuoteResp.grandTotal.selectedValue
            // this.toDisplayData.additionalCoverAmount = String(getQuoteResp.grandTotal.selectedValue.replace(/,/g, '') - Number(this.toDisplayData.basePremiumAmount.replace(/,/g, '')));
          }
          else {
            console.log('run 2')
            this.toDisplayData.basePremiumAmount = getQuoteResp.grandTotal.selectedValue;
            // this.toDisplayData.additionalCoverAmount = String(getQuoteResp.grandTotal.selectedValue.replace(/,/g, '') - Number(this.toDisplayData.basePremiumAmount.replace(/,/g, '')));
          }
        }
        else {
          console.log('run 3')
          this.toDisplayData.basePremiumAmount = getQuoteResp.outputFields[0].premium;
          this.toDisplayData.additionalCoverAmount = String(getQuoteResp.grandTotal.selectedValue.replace(/,/g, '') - Number(this.toDisplayData.basePremiumAmount.replace(/,/g, '')));
        }
        this.toDisplayData.totalPremiumAmount = getQuoteResp.grandTotal.selectedValue;
      }, err => {
        this.loader.hideLoader();
      })
    }
  }
  deductibleChange(e) {
    if (this.starProducts.isStar) {
      console.log("12121212121212", e.target.value);
      if (e.target.value === "300000" && this.careConfirmationForm.get('planType').value === 'SILVER' && this.starProducts.superSurplusIndividual) {
        this.careConfirmationForm.get('topUpCoverAmnt').setValue(700000)
      }
      else if (e.target.value === "300000" && this.careConfirmationForm.get('planType').value === 'SILVER' && this.starProducts.superSurplusFloater) {
        this.topUpCoverAmntList = this._dataFields.getTopupSumInsured().filter(item => item.value === 5)
        this.careConfirmationForm.get('topUpCoverAmnt').setValue(1000000)
        let temp3 = this._dataFields.getTopDeductible();
        let temp4 = []
        temp3.forEach(element => {
          if (element.value === 1 || element.value === 2) {
            temp4.push(element)
          }
        })
        this.deductibleList = temp4;
        this.careConfirmationForm.get('deductibles').setValue(this.deductibleList[0].label)
      }
      else if (e.target.value === "500000" && this.careConfirmationForm.get('planType').value === 'SILVER' && this.starProducts.superSurplusFloater) {
        console.log("hihihih")
        this.topUpCoverAmntList = this._dataFields.getTopupSumInsured().filter(item => item.value === 5)
        this.careConfirmationForm.get('topUpCoverAmnt').setValue(1000000)
        let temp3 = this._dataFields.getTopDeductible();
        let temp4 = []
        temp3.forEach(element => {
          if (element.value === 1 || element.value === 2) {
            temp4.push(element)
          }
        })
        this.deductibleList = temp4;
        this.careConfirmationForm.get('deductibles').setValue(this.deductibleList[0].label)
      }
      else if (e.target.value === "300000" && this.careConfirmationForm.get('planType').value === 'GOLD') {
        // let temp = this._dataFields.getTopupSumInsured();
        // let temp2 = []
        // temp.forEach(element => {
        //   if (element.value === 1 || element.value === 4 || element.value === 5 || element.value === 8 || element.value === 10 || element.value === 11 || element.value === 34 || element.value === 40 || element.value === 46) {
        //     temp2.push(element)
        //   }
        // })
        // this.topUpCoverAmntList = temp2;
        this.topUpCoverAmntList = this._dataFields.getTopupSumInsured();
      }
      else if (e.target.value != "300000") {
        this.topUpCoverAmntList = this._dataFields.getTopupSumInsured().filter(item => item.value !== 4)
        let temp = this._dataFields.getTopupSumInsured();
        let temp1 = []
        temp.forEach(element => {
          if (element.value === 1 || element.value === 5 || element.value === 8 || element.value === 10 || element.value === 11 || element.value === 34 || element.value === 40 || element.value === 46) {
            temp1.push(element)
          }
        })
        this.topUpCoverAmntList = temp1;
        if (this.careConfirmationForm.get('topUpCoverAmnt').value === "700000") {
          this.careConfirmationForm.get('topUpCoverAmnt').setValue(this.topUpCoverAmntList[0].label)
        }
      }

      if (this.starProducts.superSurplusIndividual) {
        this.topUpPvt.membersArray = []
        this.topUpPvt.membersArray.push({
          'age': this.insurerArray[0].age,
          "sumInsuredAmount": this.careConfirmationForm.get('topUpCoverAmnt').value,
          "deductible": this.careConfirmationForm.get('deductibles').value,
          "planType": this.careConfirmationForm.get('planType').value,
          'memberType': this.insurerArray[0].name
        })
      }
      else if (this.starProducts.superSurplusFloater) {
        this.topUpPvt.deductible = this.careConfirmationForm.get('deductibles').value
        this.topUpPvt.sumInsuredAmount = this.careConfirmationForm.get('topUpCoverAmnt').value
        this.topUpPvt.planType = this.careConfirmationForm.get('planType').value
      }
    }
    else if (this.careProducts) {
      console.log("3434343434343434")
      if (this.careConfirmationForm.get('deductibles').value === '200000') {
        this.careCoverAmntList = this._dataFields.getEnhanceSumInsured2()
        this.careConfirmationForm.get('coverAmnt').setValue('200000')
      }
      else if (this.careConfirmationForm.get('deductibles').value === '300000') {
        this.careCoverAmntList = this._dataFields.getEnhanceSumInsured3()
        this.careConfirmationForm.get('coverAmnt').setValue('300000')
      }
      else if (this.careConfirmationForm.get('deductibles').value === '400000') {
        this.careCoverAmntList = this._dataFields.getEnhanceSumInsured4()
        this.careConfirmationForm.get('coverAmnt').setValue('400000')
      }
      else if (this.careConfirmationForm.get('deductibles').value === '500000') {
        this.careCoverAmntList = this._dataFields.getEnhanceSumInsured5()
        this.careConfirmationForm.get('coverAmnt').setValue('500000')
      }
      else if (this.careConfirmationForm.get('deductibles').value === '600000') {
        this.careCoverAmntList = this._dataFields.getEnhanceSumInsured6()
        this.careConfirmationForm.get('coverAmnt').setValue('600000')
      }
      else if (this.careConfirmationForm.get('deductibles').value === '700000') {
        this.careCoverAmntList = this._dataFields.getEnhanceSumInsured7()
        this.careConfirmationForm.get('coverAmnt').setValue('700000')
      }
      else if (this.careConfirmationForm.get('deductibles').value === '800000') {
        this.careCoverAmntList = this._dataFields.getEnhanceSumInsured8()
        this.careConfirmationForm.get('coverAmnt').setValue('800000')
      }
      else if (this.careConfirmationForm.get('deductibles').value === '900000') {
        this.careCoverAmntList = this._dataFields.getEnhanceSumInsured9()
        this.careConfirmationForm.get('coverAmnt').setValue('900000')
      }
      else if (this.careConfirmationForm.get('deductibles').value === '1000000') {
        this.careCoverAmntList = this._dataFields.getEnhanceSumInsured10()
        this.careConfirmationForm.get('coverAmnt').setValue('1000000')
      }
    }

  }
  coverAmtChange(e) {
    if (this.starProducts.superSurplusFloater) {
      this.topUpPvt.sumInsuredAmount = this.careConfirmationForm.get('topUpCoverAmnt').value;
    }
    if (this.starProducts.superSurplusIndividual) {
      this.topUpPvt.membersArray = []
      this.sumValue = e.target.value
      this.topUpPvt.membersArray.push({
        'age': this.insurerArray[0].age,
        "sumInsuredAmount": this.sumValue,
        "deductible": this.careConfirmationForm.get('deductibles').value,
        "planType": this.careConfirmationForm.get('planType').value,
        'memberType': this.insurerArray[0].name
      })
    }
  }
  proceedtoProp() {
    if (this.careProducts.care) {
      if (this.careConfirmationForm.get('coverAmnt').value <= 5) {
        this.addOns = "CAREWITHNCB"
        this.addOnArray.push(this.addOns)
      }
      this.loader.showLoader();
      let reqInsurerProdDetail = JSON.parse(this.careQuoteRes.careQuoteRequest.reqParam)
      this.careQuoteRes.careQuoteRequest.reqParam = reqInsurerProdDetail;
      let parsedInsurer = JSON.parse(this.careQuoteRes.careQuoteResponse.insuranceQuoteRequest.reqParam)
      this.careQuoteRes.careQuoteResponse.insuranceQuoteRequest.reqParam = parsedInsurer
      this.careQuoteRes.careQuoteResponse.insuranceQuoteRequest.reqParam.insurer = parsedInsurer.insurer
      let parsedRespInsurer = JSON.parse(this.careQuoteRes.careQuoteResponse.responseParam)
      this.careQuoteRes.careQuoteResponse.responseParam = parsedRespInsurer

      let data = {
        "productName": 'CARE',
        "requestObj": this.careQuoteReq,
        "responseObj": this.careQuoteRes,
      }
      this.strg.setStoreData("hcr_careQuoteResponse", this.careQuoteRes)
      this.strg.setStoreData("hcr_addOns", this.addOnArray)
      this.apiService.saveFinalQuotation(data).subscribe(res => {
        this.strg.setStoreData("hlIncp", false);
        this.loader.hideLoader();
        this.redirectToCarekyc(); // added for care kyc flow
        // this.router.navigate(["/care-proposal-form/care"]) // commented for care kyc flow
      }, err => {
      })
    } else {
      if (this.serverQuoteRequest) {
        this.reqDataObj.serverQuoteObj = this.serverQuoteRequest
      }
      let data = {
        "productName": this.productName,
        "requestObj": this.reqDataObj,
        "responseObj": this.careQuoteRes,
      }
      console.log("###############hasgdhjagsdjhas djagsdhjgsasd###############", data);
      this.strg.setStoreData("hcr_careQuoteResponse", this.resDataObj)
      this.loader.showLoader();
      this.apiService.saveFinalQuotation(data).subscribe(res => {
        this.loader.hideLoader();
        this.strg.setStoreData("hlIncp", false);
        this.strg.setStoreData('starFormPassed', false);
        if (this.careProducts.enhance1Floater || this.careProducts.enhance1Individual) {
          this.redirectToCarekyc();
        } else {
          this.redirectToStarKyc();
        }
        // if (this.starProducts.familyHealthOptima) { // comment start for star kyc
        //   this.router.navigate(["/star-proposal-form/fho"])
        // } else if (this.starProducts.mediClassicIndividual) {
        //   this.router.navigate(["/star-proposal-form/mci"])
        // } else if (this.starProducts.redCarpetFloater) {
        //   this.router.navigate(["/star-proposal-form/rcf"])
        // } else if (this.starProducts.redCarpetIndividual) {
        //   this.router.navigate(["/star-proposal-form/rci"])
        // } else if (this.starProducts.comprehensiveFloater) {
        //   this.router.navigate(["/star-proposal-form/compf"])
        // } else if (this.starProducts.comprehensiveIndividual) {
        //   this.router.navigate(["/star-proposal-form/compi"])
        // } else if (this.starProducts.youngStarFloater) {
        //   this.router.navigate(["/star-proposal-form/ysf"])
        // } else if (this.starProducts.youngStarIndividual) {
        //   this.router.navigate(["/star-proposal-form/ysi"])
        // } else if (this.starProducts.superSurplusFloater) {
        //   this.router.navigate(["/star-proposal-form/ssf"])
        // } else if (this.starProducts.superSurplusIndividual) {
        //   this.router.navigate(["/star-proposal-form/ssi"])
        // } else if (this.careProducts.enhance1Floater) {
        //   this.router.navigate(["/care-proposal-form/enhnace1Floater"])
        // } else if (this.careProducts.enhance1Individual) {
        //   this.router.navigate(["/care-proposal-form/enhnace1Individual"])
        // } // comment end for star kyc
      }, err => {
      })
    }

  }

  async redirectToCarekyc() {
    this.strg.removeStoreData("careCkyc");
    this.strg.removeStoreData("careEkyc");
    const modal = await this.modalCtrl.create({
      component: CareKycComponent,
      componentProps: {
        dataSelected: "dataopenforcarekyc",
        // formData: this.planUpgradeForm.value
      },
      cssClass: "selected-info-modal",
      showBackdrop: false,
      backdropDismiss: false,
      swipeToClose: true
    });

    modal.onDidDismiss().then((isOkay) => {
      console.log("isOkay2Proceed", isOkay);
      if (isOkay.data.goForward) {
        // this.proceedToAppForm()
        if (isOkay.data.dataSelected?.personalDetails?.ckycNo) {
          console.log("this is confirmation page ckyc data", isOkay.data.dataSelected);
          this.strg.setStoreData("careCkyc", isOkay.data.dataSelected);
          this.strg.removeStoreData("careOvdKyc");
          if (this.careProducts.enhance1Floater) {
            this.router.navigate(["/care-proposal-form/enhnace1Floater"])
          } else if (this.careProducts.enhance1Individual) {
            this.router.navigate(["/care-proposal-form/enhnace1Individual"])
          } else {
            this.router.navigate(["/care-proposal-form/care"])
          }
        }
        else if (isOkay.data.dataSelected?.requestId) {
          console.log("this is confirmation page ekyc data", isOkay.data.dataSelected);
          this.strg.setStoreData("careEkyc", isOkay.data.dataSelected);
          window.open(isOkay.data.dataSelected.url, "_self");
        }
        else {
          if (this.careProducts.enhance1Floater) {
            this.router.navigate(["/care-proposal-form/enhnace1Floater"])
          } else if (this.careProducts.enhance1Individual) {
            this.router.navigate(["/care-proposal-form/enhnace1Individual"])
          } else {
            this.router.navigate(["/care-proposal-form/care"])
          }
        }
      }
    });

    return await modal.present();
  }

  redirectToStarKyc() {
    // this.strg.removeStoreData('starProducts');
    this.strg.removeStoreData('starCkycFormData');
    console.log("starproductsssssss", this.starProducts)
    this.strg.setStoreData('starProducts', this.starProducts).then(res => {
      this.router.navigate(["/star-ckyc/1"])
    });
  }

  unlimitRech() {
    this.unlimitAddon = !this.unlimitAddon;
    if (this.unlimitAddon) {
      this.addOns = "UAR"
      this.addOnArray.push(this.addOns)
    }
    else if (!this.unlimitAddon) {
      this.addOnArray.splice("UAR", 1)
    }
    this.updateCareQuote();
  }
  selectedOpdAmount: any;
  selectedDaAmount: any;
  showCovidCareOpdDropdown: boolean = false;
  changeOpd(event) {
    this.selectedOpdAmount = (event.target.value).replace("OPDCARE-", '');
    let el = this.addOnArray.indexOf(this.addOnArray.find(a => a.includes("OPDCARE")));
    this.addOnArray.splice(el, 1);
    this.addOnArray.push(event.target.value)
    this.updateCareQuote();
  }
  covidOpd() {
    this.opdAddon = !this.opdAddon;
    if (this.opdAddon) {
      this.selectedOpdAmount = "5000"
      this.opdValue = "OPDCARE-5000"
      this.addOns = this.opdValue
      this.addBtnShow = true;
      this.addOnArray.push(this.addOns)
    }
    else if (!this.opdAddon) {
      let el = this.addOnArray.indexOf(this.addOnArray.find(a => a.includes("OPDCARE")));
      this.addOnArray.splice(el, 1)
      this.showCovidCareOpdDropdown = false
      this.selectedOpdAmount = ''
      this.opdValue = ''
      this.addOns = ''
    }
    this.updateCareQuote();
  }
  changeDA(event) {
    this.selectedDaAmount = event.target.value;
    let el = this.addOnArray.indexOf(this.addOnArray.find(a => a.includes("DAILYALLOWANCE")));
    this.addOnArray.splice(el, 1);
    this.addOnArray.push("DAILYALLOWANCE-" + this.selectedDaAmount);
    this.updateCareQuote();
  }
  showDailyAllowanceDropdown: boolean = false;
  dailyAllowance() {
    this.dailyAllowanceAdd = !this.dailyAllowanceAdd;
    if (this.dailyAllowanceAdd) {
      this.selectedDaAmount = "1000"
      this.addOns = "DAILYALLOWANCE-1000"
      this.addOnArray.push(this.addOns)
      console.log('if')
    }
    else if (!this.dailyAllowanceAdd) {
      console.log('else')
      let el = this.addOnArray.indexOf(this.addOnArray.find(a => a.includes("DAILYALLOWANCE")));
      this.addOnArray.splice(el, 1)
      this.showDailyAllowanceDropdown = false
      this.selectedDaAmount = '';
      this.addOns = '';
    }
    this.updateCareQuote();
  }
  coPayWaiver() {
    this.coPayWaiverAdd = !this.coPayWaiverAdd;
    if (this.coPayWaiverAdd) {
      this.addOns = "COPAYWAIVER"
      this.addOnArray.push(this.addOns)
    } else if (!this.coPayWaiverAdd) {
      this.addOnArray.splice("COPAYWAIVER", 1)
    }
    this.updateCareQuote();
  }
  expertOpinion() {
    this.expertAdd = !this.expertAdd;
    if (this.productName === 'Enhance 1') {
      this.addOnsParam = true
    }
    else if (this.productName === 'Enhance 2') {
      this.addOnsParam = true
    }
    this.getStarQuote()
  }
  removeExpertOpinion() {
    this.expertAdd = !this.expertAdd;
    if (this.productName === 'Enhance 1') {
      this.addOnsParam = false
    }
    else if (this.productName === 'Enhance 2') {
      this.addOnsParam = false
    }
    this.getStarQuote()
  }
  ncbAddon() {
    this.ncbAdd = !this.ncbAdd;
    if (this.ncbAdd) {
      this.addOns = "CAREWITHNCB"
      this.addOnArray.push(this.addOns)
    } else if (!this.ncbAdd) {
      if (this.reductionAdd) {
        this.reductionAdd = false;
        this.addOnArray.splice("REDPEDWAITPRD", 1)
      }
      this.addOnArray.splice("CAREWITHNCB", 1)

    }
    this.updateCareQuote();
  }
  everyDayAddon() {
    this.everyDayAdd = !this.everyDayAdd
    if (this.everyDayAdd) {
      this.addOns = "EVERYDAYCARE"
      this.addOnArray.push(this.addOns)
    }
    else if (!this.everyDayAdd) {
      this.addOnArray.splice("EVERYDAYCARE", 1)
    }
    this.updateCareQuote();
  }
  airAmbAddon() {
    this.airAmbulance = !this.airAmbulance
    if (this.airAmbulance) {
      this.addOns = "AAC"
      this.addOnArray.push(this.addOns)
    }
    else if (!this.airAmbulance) {
      this.addOnArray.splice("AAC", 1)
    }
    this.updateCareQuote();
  }
  reductionPed() {
    this.reductionAdd = !this.reductionAdd;
    if (this.reductionAdd) {
      this.addOns = "REDPEDWAITPRD"
      this.addOnArray.push(this.addOns)
    }
    else if (!this.reductionAdd) {
      this.addOnArray.splice("REDPEDWAITPRD", 1)
    }
    this.updateCareQuote();
  }
  careShield() {
    this.careShieldAdd = !this.careShieldAdd
    if (this.careShieldAdd) {
      this.addOns = "CARESHILED1104"
      this.addOnArray.push(this.addOns)
    }
    else if (!this.careShieldAdd) {
      this.addOnArray.splice("CARESHILED1104", 1)
    }
    this.updateCareQuote();
  }
  ShowEcMore() {
    this.showEveryDayCare = !this.showEveryDayCare;
  }
  showCsMore: boolean = false;
  ShowRedMore() {
    this.showAddonsRed = !this.showAddonsRed;
  }
  showCoPaymentWaiver() {
    this.coPaymentWaiver = !this.coPaymentWaiver;
  }
  ShowAirMore() {
    this.showAirambulance = !this.showAirambulance;
  }
  async openConfirmModal(cashless) {
    const modal = await this.modalCtrl.create({
      component: HealthClaimSettlementComponent,
      componentProps: {
        dataSelected: this.members,
        cashlessOpen: cashless,
      },
      cssClass: "modal-settlement",
      showBackdrop: false,
      backdropDismiss: false,
      swipeToClose: true
    });
    modal.onDidDismiss().then((isOkay) => {
    });
    return await modal.present();

  }
  showEmiOptions: boolean = false;
  openEmiModal() {
    this.showEmiOptions = true;
  }
}
